// extracted by mini-css-extract-plugin
module.exports = {"container":"practiceTitle_container__25UYs","name":"practiceTitle_name__2G5jW","address":"practiceTitle_address__Z-G5W","innerContainer":"practiceTitle_innerContainer__3Ik2Y"};